import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

interface AddFontCardProps {
  onClick: () => void;
}

const AddFontCard = ({ onClick }: AddFontCardProps) => {
  return (
    <Button
      className="clear-button"
      height="64px"
      width="140px"
      border="1px dashed var(--gray-100)"
      backgroundColor="var(--local-upl-fill)"
      borderRadius="8px"
      onClick={onClick}
      hoverOpacity={0.8}
    >
      <Container
        width="136px"
        height="60px"
        borderRadius="8px"
        className="position-relative overflow-hidden flex fd-row jc-center ai-center padding-6"
      >
        <Icon name={ICONS.ADD} color="var(--local-upl-icotext)" />
      </Container>
    </Button>
  );
};

export default AddFontCard;
